import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { fadeInAndUp } from '../base/keyframes/fades';
import { sequencedAnimationDelay } from '../base/utils';
import { Column, asAnchor } from '../base';
import media from '../base/media';

export const Wrapper = styled.div`
	padding: 6rem 0;

	${media.tablet`
		padding: 14rem 0;
	`}
`;

export const AnimatedColumn = styled(Column)`
	opacity: 0;
	animation: ${fadeInAndUp} 300ms;
	animation-fill-mode: forwards;
	${sequencedAnimationDelay(10, 0.03)};
`;

export const TitleWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const SeeAllLink = styled(Link)`
	${asAnchor};
`;
